<template>
  <el-select
    v-if="this.getConnectors && this.getConnectors.length > 0 && !useVuetify"
    v-model="internalValue"
    @change="doChange"
    :placeholder="placeholder"
    :size="size"
    :style="style"
    :multiple="multiple"
    :collapse-tags="multiple"
    :collapse-tags-tooltip="multiple"
    :clearable="clearable"
  >
    <el-option v-if="!multiple" :value="0" :label="'Select One'"></el-option>
    <el-option
      v-for="option in this.getConnectors"
      :value="option.id"
      :key="option.id"
      :label="option.label"
    ></el-option>
  </el-select>
  <v-select
    v-else-if="this.getConnectors && this.getConnectors.length > 0 && useVuetify"
    v-model="internalValue"
    @update:model-value="doChange"
    :label="placeholder"
    :placeholder="placeholder"
    :items="selectOptions"
    :density="vuetifyDensity"
    hide-details="auto"
    variant="outlined"
    :multiple="multiple"
    clearable
    :style="style"
  ></v-select>
  <el-alert v-else title="You have zero connectors" type="warning"></el-alert>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ConnectorSelect',
  props: {
    modelValue: {
      type: [Number, String, Array],
    },
    size: {
      type: String,
      default: 'small',
    },
    placeholder: {
      type: String,
    },
    selectFirstAvailable: {
      type: Boolean,
      default: false,
    },
    style: {
      type: Object,
    },
    useVuetify: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      internalValue: undefined,
    };
  },
  computed: {
    ...mapGetters('connectors', ['getConnectors']),
    selectOptions() {
      const options = this.getConnectors.map((connector) => ({
        value: connector.id,
        title: connector.label,
      }));

      options.unshift({ value: 0, title: 'Select One' });

      return options;
    },
    vuetifyDensity() {
      const densityMap = {
        default: 'default',
        small: 'compact',
        mini: 'comfortable',
      };
      return densityMap[this.size] || 'compact';
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(val) {
        if (this.multiple) {
          this.internalValue = val || [];
          return;
        }
        if (val == undefined && this.selectFirstAvailable && this.getConnectors?.length) {
          const first = this.getConnectors.find(c => c.is_default == true);
          if (first) {
            this.internalValue = first.id;
            this.doChange();
            return;

          } else {
            this.internalValue = this.getConnectors[0].id;
            this.doChange();
            return;
          }
        }
        this.internalValue = val;
      },
    },
  },
  created() {
    if (this.multiple) {
      this.internalValue = this.modelValue || [];
      return;
    }
    if (this.selectFirstAvailable && this.getConnectors.length > 0) {
      const first = this.getConnectors.find(c => c.is_default == true);
      if (first) {
        this.internalValue = first.id;
        this.doChange();
        return;

      } else {
        this.internalValue = this.getConnectors[0].id;
        this.doChange();
        return;

      }
    }
    this.internalValue = parseInt(this.modelValue);
  },
  methods: {
    doChange() {
      this.$emit('update:modelValue', this.internalValue);
      this.$emit('change', this.internalValue);
    },
    returnValue(option) {
      return +option.id;
    },
  },
};
</script>
